import { render, staticRenderFns } from "./BranchOffices.vue?vue&type=template&id=5a1e5dc2&"
import script from "./BranchOffices.vue?vue&type=script&lang=js&"
export * from "./BranchOffices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports